import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import f from "./panelHeader.js";
import { useCalendarProps as k, useCalendar as C } from "./use-calendar.js";
import y from "../../../_internal/focus-detector/src/FocusDetector.js";
import p, { XButton as D } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as m, resolveSlot as o } from "../../../_utils/vue/resolve-slot.js";
import $ from "../../../_internal/icons/FastBackward.js";
import P from "../../../_internal/icons/Backward.js";
import _ from "../../../_internal/icons/Forward.js";
import S from "../../../_internal/icons/FastForward.js";
import b from "../../../input/src/Input.js";
import w from "../../../time-picker/src/TimePicker.js";
import { defineComponent as x, h as e } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const H = x({
  name: "DateTimePanel",
  props: k,
  setup(s) {
    return C(s, "datetime");
  },
  render() {
    var s, d, c, h;
    const {
      mergedClsPrefix: t,
      mergedTheme: i,
      shortcuts: r,
      timePickerProps: v,
      datePickerSlots: l,
      onRender: u
    } = this;
    return u == null || u(), e("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--datetime`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, e("div", {
      class: `${t}-date-panel-header`
    }, e(b, {
      value: this.dateInputValue,
      theme: i.peers.Input,
      themeOverrides: i.peerOverrides.Input,
      stateful: !1,
      size: this.timePickerSize,
      readonly: this.inputReadonly,
      class: `${t}-date-panel-date-input`,
      textDecoration: this.isDateInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleDateInputBlur,
      onUpdateValue: this.handleDateInput
    }), e(w, Object.assign({
      size: this.timePickerSize,
      placeholder: this.locale.selectTime,
      format: this.timePickerFormat
    }, Array.isArray(v) ? void 0 : v, {
      showIcon: !1,
      to: !1,
      theme: i.peers.TimePicker,
      themeOverrides: i.peerOverrides.TimePicker,
      value: Array.isArray(this.value) ? null : this.value,
      isHourDisabled: this.isHourDisabled,
      isMinuteDisabled: this.isMinuteDisabled,
      isSecondDisabled: this.isSecondDisabled,
      onUpdateValue: this.handleTimePickerChange,
      stateful: !1
    }))), e("div", {
      class: `${t}-date-panel-calendar`
    }, e("div", {
      class: `${t}-date-panel-month`
    }, e("div", {
      class: `${t}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, o(l["prev-year"], () => [e($, null)])), e("div", {
      class: `${t}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, o(l["prev-month"], () => [e(P, null)])), e(f, {
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: t,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), e("div", {
      class: `${t}-date-panel-month__next`,
      onClick: this.nextMonth
    }, o(l["next-month"], () => [e(_, null)])), e("div", {
      class: `${t}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, o(l["next-year"], () => [e(S, null)]))), e("div", {
      class: `${t}-date-panel-weekdays`
    }, this.weekdays.map((a) => e("div", {
      key: a,
      class: `${t}-date-panel-weekdays__day`
    }, a))), e("div", {
      class: `${t}-date-panel-dates`
    }, this.dateArray.map((a, n) => e("div", {
      "data-n-date": !0,
      key: n,
      class: [`${t}-date-panel-date`, {
        [`${t}-date-panel-date--current`]: a.isCurrentDate,
        [`${t}-date-panel-date--selected`]: a.selected,
        [`${t}-date-panel-date--excluded`]: !a.inCurrentMonth,
        [`${t}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a.ts, {
          type: "date",
          year: a.dateObject.year,
          month: a.dateObject.month,
          date: a.dateObject.date
        })
      }],
      onClick: () => {
        this.handleDateClick(a);
      }
    }, e("div", {
      class: `${t}-date-panel-date__trigger`
    }), a.dateObject.date, a.isCurrentDate ? e("div", {
      class: `${t}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? e("div", {
      class: `${t}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((s = this.actions) === null || s === void 0) && s.length || r ? e("div", {
      class: `${t}-date-panel-actions`
    }, e("div", {
      class: `${t}-date-panel-actions__prefix`
    }, r && Object.keys(r).map((a) => {
      const n = r[a];
      return Array.isArray(n) ? null : e(D, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(n);
        },
        onClick: () => {
          this.handleSingleShortcutClick(n);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a
      });
    })), e("div", {
      class: `${t}-date-panel-actions__suffix`
    }, !((d = this.actions) === null || d === void 0) && d.includes("clear") ? m(this.datePickerSlots.clear, {
      onClear: this.clearSelectedDateTime,
      text: this.locale.clear
    }, () => [e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.clearSelectedDateTime
    }, {
      default: () => this.locale.clear
    })]) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? m(l.now, {
      onNow: this.handleNowClick,
      text: this.locale.now
    }, () => [e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    })]) : null, !((h = this.actions) === null || h === void 0) && h.includes("confirm") ? m(l.confirm, {
      onConfirm: this.handleConfirmClick,
      disabled: this.isDateInvalid,
      text: this.locale.confirm
    }, () => [e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    })]) : null)) : null, e(y, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  H as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/datetime.js
// module id = 1626
// module chunks = 41